export default __webpack_public_path__ + "static/media/car2.617ec31f.png";